const mEditionBillingPaymentMethodsModalDelete = {
  mEditionBillingPaymentMethodsModalDelete: {
    alerts: {
      deleteAcademiaPasarelaPago: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        errorVenta: 'Esta pasarela de pago no se puede eliminar porque esta relacionada a una venta.',
        success: 'La pasarela de pago se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará la pasarela de pago ',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Pasarela de Pago'
  }
}

export default mEditionBillingPaymentMethodsModalDelete
